import { Component, input, InputSignal } from '@angular/core';

import { CmsBtn } from '@shared/ui/cms-btn/cms-btn';
import { CmsStyles } from '@shared/directives/cms-styles/cms-styles.directive';
import { TrustHtmlPipe } from '@shared/pipes/trust-html/trust-html.pipe';
import { FooterLinks } from '@core/cms/landing.cms';

/** Renders a single `footer-sections.footer-links` block as a footer column. */
@Component({
    selector: 'app-footer-links-column',
    imports: [CmsBtn, CmsStyles, TrustHtmlPipe],
    templateUrl: './footer-links-column.html',
    styleUrl: './footer-links-column.scss',
})
export class FooterLinksColumn {
    /** The CMS link block to render. */
    public readonly block: InputSignal<FooterLinks> = input.required<FooterLinks>();
}
